import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex } from 'reflexbox'

import { SemiTitle } from 'components/Typography'
import { RadioField } from 'components/Form'

const RadioGroup = ({ label, name, direction, options, ...props }) => (
  <Box {...props}>
    <Box mb='10px'>
      <SemiTitle color='grays.N500'>{label}</SemiTitle>
    </Box>

    <Flex flexDirection={direction}>
      {options.map((option, index) => (
        <RadioField key={index} name={name} {...option} />
      ))}
    </Flex>
  </Box>
)
RadioGroup.defaultProps = {
  direction: 'column',
}

RadioGroup.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  direction: PropTypes.oneOf(['row', 'column']),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  ...Box.propTypes,
}

export default RadioGroup
